import React from "react";
import { useTranslation } from "react-i18next";

const BecomePartner = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="container bg-white px-40 py-5">
        <div id="heading" className="text-center">
          <h2 className="text-2xl my-3 font-bold">{t("becomePartnerTitle")}</h2>
          <h3 className="font-semibold mb-5">{t("becomePartnerSubtitle")}</h3>
          <hr className="my-10 w-1/3 mx-auto border-4 border-gray-100 rounded-lg shadow-md shadow-gray-400/50" />

          <p className="px-xs my-5">{t("becomePartnerDescription")}</p>
        </div>

        <div id="content" className="flex gap-10 my-5 items-center">
          <div className="flex h-72 flex-1">
            <div className="flex border w-full h-full">
              <img
                src="https://i.pinimg.com/736x/83/e2/c2/83e2c215eaefb7d936d080037707c9b6.jpg"
                alt={t("partnerImageAlt")}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col space-y-5">
            <p>{t("partnerDescription")}</p>
            <button className="w-1/2 mx-auto uppercase font-semibold px-5 py-2 rounded-md bg-orange-500">
              {t("becomePartnerButton")}
            </button>
          </div>
        </div>
        <hr className="my-10 border border-black w-1/3 mx-auto" />

        <div id="partner-advantage" className="space-y-3">
          <h2 className="text-2xl font-bold mb-5">
            {t("partnerAdvantageTitle")}
          </h2>

          <div className="flex gap-10 w-full items-center">
            <div className="flex flex-1 flex-col space-y-5">
              <h3 className="text-md font-bold">
                {t("driveHighValueCustomerInflow")}
              </h3>
              <p>{t("driveHighValueCustomerInflowDesc")}</p>
            </div>
            <div className="flex w-1/5 h-40">
              <img
                src="/images/1f5a8eb97fae36c352f4794aa784866394de6b2e.png"
                alt={t("customerInflowIconAlt")}
                width={100}
                height={100}
                className="h-full w-full"
              />
            </div>
          </div>

          <div className="flex gap-10 w-full items-center">
            <div className="flex w-1/5 h-40">
              <img
                src="/images/e1b90906fe13e20d15f8c57ea58451370722bf5f.png"
                alt={t("discountSavingsIconAlt")}
                width={100}
                height={100}
                className="h-full w-full"
              />
            </div>

            <div className="flex flex-1 flex-col space-y-5">
              <h3 className="text-md font-bold">
                {t("doubleDiscountsIntoSavings")}
              </h3>
              <p>{t("doubleDiscountsIntoSavingsDesc")}</p>
            </div>
          </div>

          <div className="flex gap-10 w-full items-center">
            <div className="flex flex-1 flex-col space-y-5">
              <h3 className="text-md font-bold">
                {t("buildLastingCustomerLoyalty")}
              </h3>
              <p>{t("buildLastingCustomerLoyaltyDesc")}</p>
            </div>
            <div className="flex w-1/5 h-40">
              <img
                src="/images/b8feb8e4c9bb8346f258c83a502c6155ddd31068.png"
                alt={t("customerLoyaltyIconAlt")}
                width={100}
                height={100}
                className="h-full w-full"
              />
            </div>
          </div>

          <div className="flex gap-10 w-full items-center">
            <div className="flex w-1/5 h-40">
              <img
                src="/images/32b5cdd0a2aa7079c53d32f072175eacf94a10a1.png"
                alt={t("promotionalVisibilityIconAlt")}
                width={100}
                height={100}
                className="h-full w-full"
              />
            </div>

            <div className="flex flex-1 flex-col space-y-5">
              <h3 className="text-md font-bold">
                {t("gainPromotionalVisibility")}
              </h3>
              <p>{t("gainPromotionalVisibilityDesc")}</p>
            </div>
          </div>
        </div>

        <hr className="w-1/3 mx-auto shadow-lg border-black border my-10" />

        <div className="mx-auto w-3/5 space-y-5 text-center">
          <h2 className="text-2xl font-bold">
            {t("readyToGrowBusinessAndSavings")}
          </h2>
          <p>{t("joinForwardThinkingMerchants")}</p>
          <button className="font-semibold uppercase px-5 py-2 rounded-md bg-orange-500">
            {t("becomePartnerButton")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BecomePartner;
